import { AccountPage } from "@common-components/account-page/account-page";
import BTThemeProvider from "@common-components/bt-theme-provider";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { activeSubscriptionTypeSelector, latestSubscriptionTypeSelector } from "@common-reducers/UserSelectors";
import AdminBillingView from "@common-views/admin-billing/admin-billing";
import ChargebeeAdminPortal from "@common-views/chargebee-admin-portal/chargebee-admin-portal";

export const UnifiedAdminBilling = () => {

    const latestSubscriptionType = useAppSelector(latestSubscriptionTypeSelector) ?? null;
    const activeSubscriptionType = useAppSelector(activeSubscriptionTypeSelector) ?? null;

    const subscriptionType = activeSubscriptionType || latestSubscriptionType;

    return (
        <BTThemeProvider>
            <AccountPage
                page={subscriptionType === 'chargebee' ? <ChargebeeAdminPortal /> : <AdminBillingView />}
            ></AccountPage>
        </BTThemeProvider>
    );
}